import React, { useEffect, useState } from "react";
import {
  AlertCircle,
  ArrowRight,
  Banknote,
  CarFront,
  CheckCircle2,
  Cog,
  Copy,
  CreditCard,
  FileJson,
  Info,
  ListCheck,
  Loader,
  Loader2,
  Phone,
  User,
  UserCheck,
  XCircle,
} from "lucide-react";

import {
  Car,
  FileText,
  Calendar,
  MapPin,
  Building2,
  IndianRupee,
  Gavel,
} from "lucide-react";

import { isAlphanumeric, isNumeric } from "validator";


import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/profile/profileservice";
import Seo from "../../../Components/SeoComponent/Seo";
import Header from "../../../Components/Header";
import { useService } from "../../../context/ServiceContext";
import { verifyMobileToAccountSrv2 } from "../../../Services/ApiTestService/apiTestService";

function MobileToAccountSrv2() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const [mobileNo, setMobileNo] = useState("");
  const [name, setName] = useState("");
  const [inputError, setInputError] = useState(null);
  const [isJsonCopied, setIsJsonCopied] = useState(null);
  const { serviceName } = useService();

  const [profileData, setProfileData] = useState(null);
  let apiResponse;

  const isNumber = (value) => {
     if (!value) return false;
 
     return isNumeric(value, { no_symbols: true });
   };
 

  const handleCopy = (data) => {
    navigator.clipboard
      .writeText(JSON.stringify(data, null, 2))
      .then(() => showSuccessToast("Copied!"));

    setIsJsonCopied(true);
  };

  const handleMobileToAccount = async () => {
    if (!profileData) return;

    const validateMobileNum = isNumber(mobileNo);

    if (!mobileNo) {
      return setInputError("Mobile Number is Required");
    }

    if (mobileNo && !validateMobileNum) {
      return setInputError(
        "⚠️ Please enter Number in Mobile No. field",
      );
    }

    try {
      setInputError(null);
      setIsLoading(true);
      setResponse(null);

      const res = await verifyMobileToAccountSrv2({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        mobile: mobileNo.trim()?.toUpperCase(),
        name: name,
      });

      if (res) {
        apiResponse = res;
      }
      setResponse(apiResponse);

      if (res?.status?.code === 200) {
        showSuccessToast(res?.message || "Success");
      } else if (res?.status?.code === 422) {
        showErrorToast(res?.data?.message || "invalid details ");
      } else if (res?.status?.code === 500) {
        showErrorToast(res?.data?.message || "server error");
      } else if (!res.success) {
        showErrorToast(res?.data?.message || "verificaton failed");
      } else {
        showErrorToast(res?.data?.message || "something went wrong");
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Server error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- FETCH PROFILE ----------------
  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        const res = await fetchProfile();
        setProfileData(res?.data || null);
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

  return (
    <>
      <Seo />
      <Header heading={serviceName} />

      {isLoading && (
        <div className="flex justify-center mt-6">
          <Loader className="animate-spin" />
        </div>
      )}

      <div className="w-full min-h-screen flex flex-col items-center justify-start pb-14">
        {/* ---------------- FORM ---------------- */}
        <div className="max-w-4xl w-full rounded-2xl border border-slate-200 bg-white p-6 shadow-xl shadow-slate-100">
          {/* Header */}
          <div className="flex items-center gap-3 border-b border-slate-100 pb-5">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100 text-blue-600">
              <Banknote size={24} />
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800">
                {serviceName}
              </h2>
              <p className="text-sm text-slate-500">
                Verify Account details using Mobile number and name.
              </p>
            </div>
          </div>

          {/* Inputs */}
          <div className="mt-6  gap-6 flex justify-center items-center">
            {/* Mobile Number */}
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <Phone size={17} className="text-blue-600" />
                Mobile Number <span className="text-red-600">*</span>
              </label>

              <input
                type="text"
                maxLength={10}
                value={mobileNo}
                onChange={(e) => setMobileNo(e.target.value)}
                placeholder="Eg: 7858987584"
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-3 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <User size={17} className="text-blue-600" />
                Name  <span className="text-red-600 text-xs">Optional But Recommended</span>
              </label>

              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Eg: Abhishek Tripathi"
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-3 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>

            {/* Button */}
            <div className="mt-8 flex ">
              <button
                disabled={isLoading || !mobileNo || mobileNo.length !== 10}
                onClick={handleMobileToAccount}
                className="group inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 px-7 py-3 font-semibold text-white shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-50"
              >
                {isLoading ? (
                  <>
                    <Loader2 size={18} className="animate-spin" />
                    Verifying...
                  </>
                ) : (
                  <>
                    Verify
                    <ArrowRight
                      size={18}
                      className="transition-transform duration-300 group-hover:translate-x-1"
                    />
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Error */}
          {inputError && (
            <div className="mt-5 flex items-center gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-red-700">
              <AlertCircle size={18} />
              <span className="text-sm font-medium">{inputError}</span>
            </div>
          )}
        </div>

        {/* response message */}

        {response && (
          <div
            className={` ${response.status?.code === 500 || response.status?.code === 422 ? "text-red-500" : "text-green-600"} py-4 text-2xl font-bold`}
          >
            {response?.data?.message || response?.message}
          </div>
        )}

        {/* instructions */}

        <div className="w-full flex justify-center">
          <div className="bg-green-100 max-w-3xl border border-green-400 text-green-700 p-5 mt-12 rounded-2xl">
            <h3 className="font-bold flex items-center justify-start gap-2 text-lg mb-2">
              <Info /> Important Instructions{" "}
              <span className="text-red-600">*</span>
            </h3>

            <p className="text-sm leading-relaxed">
              Please enter a valid Mobile Number and name. Clicking the Verify button.
              After successful verification, the system will return the response
              in structured format, including details associated with
              the provided details. You may review and copy the data for your
              reference or further use.
            </p>
          </div>
        </div>

        {/* ---------------- RESULT ---------------- */}
        {response?.status?.code === 200 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10 w-full max-w-6xl">
            {/* -------- JSON VIEW -------- */}
            <div className="bg-gray-900 relative text-green-300 p-4 rounded-md overflow-auto">
              <button
                onClick={() => handleCopy(response)}
                className="absolute text-white top-4 right-8"
              >
                {isJsonCopied ? "copied" : <Copy />}
              </button>
              <p className="font-bold mb-2 text-2xl flex items-center justify-start md:justify-center gap-2 text-white">
                <FileJson /> JSON response
              </p>
              <hr className="mb-2" />{" "}
              <pre className="text-[16px]">
                {JSON.stringify(response, null, 2)}
              </pre>
            </div>

         
              {response?.status?.code === 200 && (
               <BankDetailsCard response={response}/>
              )}
          </div>
        )}
      </div>
    </>
  );
}

export default MobileToAccountSrv2;

 function BankDetailsCard({ response }) {
  const data = response?.data;
  const result = data?.result;
  const vpa = result?.vpa_details;
  const account = result?.account_details;
  const bank = result?.bank_details;

  return (
    <div className="bg-gray-100 p-6 rounded-xl shadow-md max-w-3xl mx-auto border border-gray-200">
      {/* Header */}
      <h2 className="text-2xl flex items-center justify-center gap-2 font-bold text-blue-600 mb-6">
        <ListCheck className="w-7 h-7" />
        Bank Account Verification Details
      </h2>

      {response?.status?.code === 200 && data && (
        <div className="space-y-6">
          {/* Status & Reference Header */}
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 flex flex-wrap justify-between items-center gap-4 text-sm">
            <div>
              <span className="text-gray-500 block text-xs font-semibold uppercase">Request ID</span>
              <span className="font-mono text-gray-700 font-medium">{data.request_id}</span>
            </div>
            <div>
              <span className="text-gray-500 block text-xs font-semibold uppercase">Client Ref Num</span>
              <span className="font-mono text-gray-700 font-medium">{data.client_ref_num}</span>
            </div>
            <div>
              <span className="text-gray-500 block text-xs font-semibold uppercase">Status</span>
              <span className="inline-flex items-center gap-1 font-semibold text-green-600 bg-green-50 px-2.5 py-1 rounded-full text-xs">
                <CheckCircle2 className="w-3.5 h-3.5" /> Success (Code {result?.result_code})
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* VPA Details */}
            <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
              <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4 flex items-center gap-2 border-b pb-2">
                <UserCheck className="w-4 h-4 text-blue-500" />
                VPA & Name Verification
              </h3>
              <dl className="space-y-3 text-sm">
                <div>
                  <dt className="text-gray-500 text-xs">Account Holder Name</dt>
                  <dd className="font-semibold text-gray-900">{vpa?.account_holder_name || 'N/A'}</dd>
                </div>
                <div>
                  <dt className="text-gray-500 text-xs">VPA (UPI ID)</dt>
                  <dd className="font-mono text-gray-800">{vpa?.vpa || 'N/A'}</dd>
                </div>
                <div className="pt-1">
                  <dt className="text-gray-500 text-xs mb-1">Name Match Status</dt>
                  <dd className="flex items-center justify-between">
                    <span className={`inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-md font-medium ${
                      vpa?.name_match 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {vpa?.name_match ? (
                        <>
                          <CheckCircle2 className="w-3.5 h-3.5" /> Match Confirmed
                        </>
                      ) : (
                        <>
                          <XCircle className="w-3.5 h-3.5" /> Mismatch
                        </>
                      )}
                    </span>
                    <span className="text-xs font-medium text-gray-600">
                      Score: <strong className="text-gray-900">{vpa?.name_match_score}%</strong>
                    </span>
                  </dd>
                </div>
              </dl>
            </div>

            {/* Account Details */}
            <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
              <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4 flex items-center gap-2 border-b pb-2">
                <CreditCard className="w-4 h-4 text-blue-500" />
                Account Information
              </h3>
              <dl className="space-y-3 text-sm">
                <div>
                  <dt className="text-gray-500 text-xs">Account Number</dt>
                  <dd className="font-mono text-gray-900 font-medium">{account?.account_number || 'N/A'}</dd>
                </div>
                <div>
                  <dt className="text-gray-500 text-xs">IFSC Code</dt>
                  <dd className="font-mono text-gray-800">{account?.account_ifsc || 'N/A'}</dd>
                </div>
                <div>
                  <dt className="text-gray-500 text-xs">Penny Deposit Amount</dt>
                  <dd className="font-medium text-gray-900">
                    ₹{parseFloat(account?.amount_deposited || 0).toFixed(2)}
                  </dd>
                </div>
              </dl>
            </div>
          </div>

          {/* Bank Details */}
          <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4 flex items-center gap-2 border-b pb-2">
              <Building2 className="w-4 h-4 text-blue-500" />
              Bank & Branch Information
            </h3>
            <div className="grid grid-cols-1  gap-4 text-sm">
              <div>
                <span className="text-gray-500 block text-xs">Bank Name</span>
                <span className="font-semibold text-gray-900">{bank?.bank_name || 'N/A'}</span>
              </div>
              <div>
                <span className="text-gray-500 block text-xs">Branch</span>
                <span className="font-medium text-gray-800">{bank?.bank_branch || 'N/A'}</span>
              </div>
              <div>
                <span className="text-gray-500 block text-xs">Bank Address</span>
                <span className="text-gray-700">{bank?.bank_address || 'N/A'}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}